import { useQuery, useQueryClient, useMutation } from "react-query";
import {
  getAllTeamsByTenantId,
  getTeamDetailsById,
  getAllObjectiveByTeamId,
  getAllKeyResultByObjectiveId,
  getAllBAUsByTeamId,
  getAllTeamStatusByTenantId,
  getAlignmentMeetingDetailsByMeetingId,
  getWebObjectiveDetailsCheckinMeetingByTeamId,
  getAllTeamsForSelByTenantId,
  getAllMeetingsTypeByTenantId,
  addMeeting,
  getAllMyMeetingByIds,
  getWebCheckinMyMeetingDetailsByMeetingId,
  getWebObjectiveDetailsCheckinMyMeetingByTeamId,
  getMeetingKeyResultValueById,
  getMeetingDetailById,
  getAlignmentMeetingDetailById,
  editMeeting,
  editAlignmentMeeting,
  getAllAlignmentMeetingsByTenantId,
  getAllAlignmentMeetingsByTenantId1,
  deleteMeeting,
  deleteAlignmentMeeting,
  // getAllMeetingByIds
} from "../Api/Index";
import {
  setMeetingsListR,
  setObjectivieR,
  setKeyResultsR,
  setLoadingR,
} from "../../Meeting/MeetingsSlice/MeetingsSlice";
// import {
//   setMyMeetingsListR,
//   setMyObjectivieR,
//   setMyKeyResultsR,
// } from "../MyMeetingsSlice/MyMeetingsSlice";
import { useDispatch, useSelector } from "react-redux";
import { setTeamsDataR } from "../../Meeting/MeetingsSlice/MeetingsSlice";
// import { setMyTeamsDataR } from "../MyMeetingsSlice/MyMeetingsSlice";
// useQuery

// const useGetAllMeetings = (meetIds: any | null) => {
//   const dispatch = useDispatch();
//   return useQuery(["getAllMeetingByIds", meetIds], getAllMeetingByIds, {
//     // staleTime: 0,
//     cacheTime: Infinity,
//     enabled: !!meetIds,
//     // refetchOnWindowFocus: false,
//     onError: (err) => {
//       // console.log(err)
//     },
//     select: (data: any) => {
//       let rawData = data?.data.data;
//       // console.log(rawData)
//       dispatch(setMeetingsListR(rawData));
//       return rawData;
//     },
//   });
// };

const useGetAllAlignmentMeetingsByTenantId = (meetIds: any | null) => {
  const dispatch = useDispatch();
  return useQuery(["getAllAlignmentMeetingsByTenantId", meetIds], getAllAlignmentMeetingsByTenantId, {
    // staleTime: 0,
    cacheTime: Infinity,
    enabled: !!meetIds,
    refetchOnWindowFocus: false,
    onError: (err) => {
      // console.log(err)
    },
    select: (data: any) => {
      let rawData = data?.data.data;
      // console.log(rawData)
      dispatch(setMeetingsListR(rawData));
      return rawData;
    },
  });
};

const useEditAlignmentMeeting = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => editAlignmentMeeting(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("getAllAlignmentMeetingsByTenantId");
    },
  });
};

const useDeleteAlignmentMeeting = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => deleteAlignmentMeeting(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("getAllAlignmentMeetingsByTenantId");
      //   console.log(data)
    },
  });
};

const useGetAllAlignmentMeetingsByTenantId1 = (meetIds: any | null) => {
  const dispatch = useDispatch();
  return useQuery(["getAllAlignmentMeetingsByTenantId1", meetIds], getAllAlignmentMeetingsByTenantId1, {
    // staleTime: 0,
    cacheTime: Infinity,
    enabled: !!meetIds,
    refetchOnWindowFocus: false,
    onError: (err) => {
      // console.log(err)
    },
    select: (data: any) => {
      let rawData = data?.data.data;
      // console.log(rawData)
      dispatch(setMeetingsListR(rawData));
      return rawData;
    },
  });
};

const useGetTeamsByTenantId = (
  getTeamsSuccess: any,
  getTeamsFailed: any,
  id: string
) => {
  return useQuery(["getTeamsByTenantId", id], getAllTeamsByTenantId, {
    refetchOnWindowFocus: false,
    // cacheTime:Infinity,
    enabled: !!id,
    onSuccess: (data) => {
      getTeamsSuccess();
    },
    onError: (err) => {
      getTeamsFailed();
    },
  });
};

const useGetTeamDetailsById = () => {
  return useQuery(["getTeamDetailsById"], getTeamDetailsById, {
    onSuccess: (data) => {
      //    console.log(data)
    },
    onError: (err) => {
      // console.log(err)
    },
  });
};
// nbiiiiajdliJDFLSDJfZDlZDh bikohodiiiiiiiiii

const useGetAllObjectiveByTeamId = (nodeId: any) => {
  const dispatch = useDispatch();
  return useQuery(
    ["getAllObjectiveByTeamId", nodeId],
    getAllObjectiveByTeamId,
    {
      enabled: !!nodeId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        let rawData = data?.data?.data;
        //    console.log(rawData)
        dispatch(setObjectivieR(rawData));
      },
      onError: (err) => {
        // console.log(err)
      },
    }
  );
};

const useGetAllKeyResultByObjectiveId = (objectiveId: any) => {
  const dispatch = useDispatch();
  return useQuery(
    ["GetAllKeyResultByObjectiveId", objectiveId],
    getAllKeyResultByObjectiveId,
    {
      enabled: !!objectiveId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err) => {
        // console.log(err)
      },
      onSuccess: (data) => {
        //    console.log(data)
        let rawdata = data?.data.data;
        //    console.log(rawdata);
        dispatch(setKeyResultsR(rawdata));
      },
    }
  );
};

const useGetAllTeamStatusByTenantId = (id: any) => {
  return useQuery(
    ["getAllTeamStatusByTenantId", "f64c1efe-4213-4502-ab8a-018c88bc9f2d"],
    getAllTeamStatusByTenantId,
    {
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      enabled: !!id,
      onSuccess: (data) => {
        //  console.log(data)
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );
};

const useGetAlignmentMeetingDetailsByMeetingId = (
  getDetSuccess: any,
  getDetFailed: any,
  id: string
) => {
  const dispatch = useDispatch();
  return useQuery(
    ["getAlignmentMeetingDetailsByMeetingId", id],
    getAlignmentMeetingDetailsByMeetingId,
    {
      enabled: !!id,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        // console.log(data)
        getDetSuccess(data);
        //
      },
      onError: (er) => {
        // console.log(er)
        getDetFailed();
      },
      select: (data) => {
        //  console.log(data)
        let teamData = data?.data?.data;
        // console.log(teamData)
        dispatch(setTeamsDataR(teamData));
        return teamData; //NADERI
      },
    }
  );
};

const UseGetWebCheckinMyMeetingDetailsByMeetingId = (
  getDetSuccess: any,
  getDetFailed: any,
  id: string
) => {
  const dispatch = useDispatch();
  return useQuery(
    ["getWebCheckinMyMeetingDetailsByMeetingId", id],
    getWebCheckinMyMeetingDetailsByMeetingId,
    {
      enabled: !!id,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        // console.log(data)
        getDetSuccess(data);
        //
      },
      onError: (er) => {
        // console.log(er)
        getDetFailed();
      },
      select: (data) => {
        //  console.log(data)
        let teamData = data?.data?.data;
        // console.log(teamData)
        dispatch(setTeamsDataR(teamData));
        return teamData; //NADERI
      },
    }
  );
};

const useGetAllObjectiveByTeamId2 = (nodeId: any) => {
  const dispatch = useDispatch();
  return useQuery(
    ["getAllObjectiveByTeamId", nodeId],
    getAllObjectiveByTeamId,
    {
      enabled: false,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        let rawData = data?.data?.data;
        //    console.log(rawData)
        dispatch(setObjectivieR(rawData));
      },
      onError: (err) => {
        // console.log(err)
      },
    }
  );
};

const useGetWebObjectiveDetailsCheckinMeetingByTeamId = (
  getObjectiveSuccess: any,
  getObjectiveError: any,
  id: String,
  priodId: string,
  meetingId: string
) => {
  // console.log(priodId)
  const dispatch = useDispatch();
  return useQuery(
    ["getWebObjectiveDetailsCheckinMeetingByTeamId", id, priodId, meetingId],
    getWebObjectiveDetailsCheckinMeetingByTeamId,
    {
      cacheTime: 1000,
      refetchOnWindowFocus: false,
      staleTime: 1000,
      enabled: !!id,
      onSuccess: (data) => {
        let rawData = data?.data?.data;
        // console.log(rawData)
        dispatch(setObjectivieR(rawData));
        getObjectiveSuccess(rawData);
        // return rawData
      },
      onError: (err) => {
        // console.log(err)

        getObjectiveError();
      },
      select: (data) => {
        return data;
      },
    }
  );
};

const useGetWebObjectiveDetailsCheckinMyMeetingByTeamId = (
  getObjectiveSuccess: any,
  getObjectiveError: any,
  id: String,
  priodId: string,
  meetingId: string
) => {
  // console.log(priodId)
  const dispatch = useDispatch();
  return useQuery(
    ["getWebObjectiveDetailsCheckinMyMeetingByTeamId", id, priodId, meetingId],
    getWebObjectiveDetailsCheckinMyMeetingByTeamId,
    {
      cacheTime: 1000,
      refetchOnWindowFocus: false,
      staleTime: 1000,
      enabled: !!id,
      onSuccess: (data) => {
        let rawData = data?.data?.data;
        // console.log(rawData)
        dispatch(setObjectivieR(rawData));
        getObjectiveSuccess(rawData);
        // return rawData
      },
      onError: (err) => {
        // console.log(err)

        getObjectiveError();
      },
      select: (data) => {
        return data;
      },
    }
  );
};

const useGetAllBAUsByTeamId = (
  getObjectiveSuccess: any,
  getObjectiveError: any,
  id: String,
  priodId: string,
  meetingId: string
) => {
  const dispatch = useDispatch();
  return useQuery(
    ["getAllBAUsByTeamId", id, priodId, meetingId],
    getAllBAUsByTeamId,
    {
      cacheTime: 1000,
      refetchOnWindowFocus: false,
      staleTime: 1000,
      enabled: !!id,
      onSuccess: (data) => {
        let rawData = data?.data?.data;
        dispatch(setObjectivieR(rawData));
        getObjectiveSuccess(rawData);
      },
      onError: (err) => {
        getObjectiveError();
      },
      select: (data) => {
        return data;
      },
    }
  );
};

const useGetWebObjectiveDetailsCheckinMeetingByTeamId2 = (
  getObjectiveSuccess: any,
  getObjectiveError: any,
  id: String,
  priodId: string,
  meetingId: string
) => {
  const dispatch = useDispatch();
  return useQuery(
    [
      "useGetWebObjectiveDetailsCheckinMeetingByTeamId2",
      id,
      priodId,
      meetingId,
    ],
    getWebObjectiveDetailsCheckinMeetingByTeamId,
    {
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      enabled: false,
      onSuccess: (data) => {
        let rawData = data?.data?.data;
        dispatch(setObjectivieR(rawData));
        getObjectiveSuccess();
      },
      onError: (err) => {
        getObjectiveError();
      },
    }
  );
};

const useGetAllTeamsForSelByTenantId = (tenantId: any) => {
  return useQuery(
    ["getAllTeamsForSelByTenantId", tenantId],
    getAllTeamsForSelByTenantId,
    {
      enabled: !!tenantId,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        // console.log(data)
      },

      onError: (err) => {
        // console.log(err)
      },
      select: (data) => {
        let rawData = data?.data?.data;
        let readyData = rawData.map(({ id, name }: any) => {
          return { key: name, value: id };
        });
        return readyData;
      },
    }
  );
};

const useGetAllMeetingsTypeByTenantId = (tenantId: any) => {
  return useQuery(
    ["GetAllMeetingsTypeByTenantId", tenantId],
    getAllMeetingsTypeByTenantId,
    {
      enabled: !!tenantId,
      refetchOnWindowFocus: false,
      onError: (err) => {
        // console.log(err)
      },
      onSuccess: (data) => {},
      // select: (data: any) => {
      //   let rawData = data?.data?.data;
      //   let readyData: any[] = rawData.map(({ id, name }: any) => {
      //     return { key: name, value: id };
      //   });
      //   return readyData;
      // },
      select: (data: any) => {
        let rawData = data?.data?.data;
        let tranFormed;
        if (rawData) {
          tranFormed = rawData.map(({ name, id,description }: any) => {
            return { key: name, value: id ,desc: description};
          });
        }
        return tranFormed;
      },
    }
  );
};

const useAddMeeting = (addMeetingSuccess: any) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => addMeeting(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("getAllAlignmentMeetingsByTenantId");
    },
  });
};

// getMeetingKeyResultValueById
const useGetMeetingKeyResultValueById = (ids: any) => {
  return useQuery(
    ["getMeetingKeyResultValueById", ids],
    getMeetingKeyResultValueById,
    {
      enabled: !!ids,
      refetchOnWindowFocus: false,
      select: (data: any) => {
        let rawData = data?.data?.data;
        return rawData;
      },
    }
  );
};

const useGetMeetingDetailById = (meetId: any) => {
  return useQuery(["GetMeetingDetailById", meetId], getMeetingDetailById, {
    enabled: !!meetId,
    refetchOnWindowFocus: false,
    select: (data: any) => {
      let rawData = data?.data?.data;
      return rawData;
    },
  });
};

const useGetAlignmentMeetingDetailById = (meetId: any) => {
  return useQuery(["GetAlignmentMeetingDetailById", meetId], getAlignmentMeetingDetailById, {
    enabled: !!meetId,
    refetchOnWindowFocus: false,
    select: (data: any) => {
      let rawData = data?.data?.data;
      return rawData;
    },
  });
};

const useEditMeeting = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => editMeeting(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("getAllMeetingByIds");
    },
  });
};

const useDeleteMeeting = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => deleteMeeting(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("getAllMeetingByIds");
    },
  });
};

export {
  useGetTeamsByTenantId,
  useGetTeamDetailsById,
  useGetAllObjectiveByTeamId,
  useGetAllKeyResultByObjectiveId,
  useGetAllTeamStatusByTenantId,
  useGetAlignmentMeetingDetailsByMeetingId,
  UseGetWebCheckinMyMeetingDetailsByMeetingId,
  useGetWebObjectiveDetailsCheckinMeetingByTeamId,
  useGetAllBAUsByTeamId,
  useGetAllTeamsForSelByTenantId,
  useGetAllMeetingsTypeByTenantId,
  useAddMeeting,
  useGetWebObjectiveDetailsCheckinMyMeetingByTeamId,
  useGetWebObjectiveDetailsCheckinMeetingByTeamId2,
  useGetMeetingKeyResultValueById,
  useGetMeetingDetailById,
  useEditMeeting,
  useEditAlignmentMeeting,
  useGetAllAlignmentMeetingsByTenantId,
  useGetAllAlignmentMeetingsByTenantId1,
  useDeleteMeeting,
  useGetAlignmentMeetingDetailById,
  useDeleteAlignmentMeeting
};
